import secondaryButtonColorBorderTextRule from '../../../../../common/algorithms/secondary-button-color-border-text-rule';

const primary = (params) => {
  const { primaryColor, backgroundColor, whiteColor } = params;
  const color = secondaryButtonColorBorderTextRule(params);

  return primaryColor.equals(backgroundColor) ? whiteColor : color;
};

export default primary;
